/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';

export const objectiveHealthResponseSchema = z.object({
  healthLevel: z.enum(['HEALTHY', 'NEEDS_ATTENTION', 'ACTION_REQUIRED', 'DONE']).nullish(),
  linkedItemCount: z.int(),
  objectiveId: z.int(),
  progressComputedAt: z.iso.datetime().nullish(),
  progressPercentage: z.number().nullish(),
});
